<template>
  <div class="d-flex flex-column">

    <div class="cert-home-intro py-5 d-flex">
      <div class="cert-home-backdrop"></div>
      <div class="cert-home-backdrop-skewed one"></div>
      <div class="cert-home-backdrop-skewed two"></div>
      <div class="cert-home-backdrop-skewed three"></div>
      <div class="cert-home-backdrop-skewed four"></div>
      <div class="col-12 col-sm-11 col-lg-10 col-xl-9 mx-auto my-auto d-flex flex-row flex-wrap px-2">
        <div class="d-flex flex-column col-12 col-lg-6">
          <div class="cert-content mt-auto">
            <div ref="title" class="cert-title">
              Rwanda CERT
            </div>
            <div ref="title-text" class="cert-text">
              The Rwanda Computer Emergency Response Team (Rw-CERT) supports public and private institutions
              affected by cyber incidents, providing information and recommendations.
              The team coordinates efforts for early detection, prevention, and response against cyber-related
              incidents.
            </div>
          </div>
          <div ref="about-btn" class="d-flex flex-row">
            <div class="d-block d-lg-none ml-auto"></div>
            <div @click="()=>$router.push({path:'about'})" class="mb-auto mt-3 mt-lg-5 cert-btn px-4 py-2">About Us
            </div>
          </div>
        </div>
        <div class="d-flex flex-column col-12 col-sm-9 col-md-6 col-lg-5 col-xl-4 ml-auto mt-4 mt-lg-auto mb-lg-auto ml-auto">
          <div>
            <cert-alert-caroussel-vertical/>
          </div>
        </div>
        <div class="d-lg-none mr-auto"></div>

      </div>
    </div>

    <!--    AWARENESS-->
    <div ref="awareness">
      <cert-awareness-caroussel/>
    </div>

    <!--    ALERTS-->
    <div ref="alerts" class="cert-section-light py-5">
      <div class="mt-2 mx-auto col-11 col-lg-9 d-flex flex-row flex-wrap">
        <div ref="advisory_partners" class="d-flex flex-column col-12 col-lg-7 mr-auto">
          <div class="cert-section-title mb-3">
            Advisories
          </div>
          <div class="cert-home-content">
            <cert-alert-caroussel/>
          </div>

          <div class="mt-5"></div>
          <div class="cert-section-title mb-3 mt-5">
            Partners
          </div>
          <div class="col-12 mx-auto row py-3">
            <div class="col-12 col-sm-6 d-flex">
              <a href="//cyber.gov.rw" target="_blank" class="mx-auto my-2">
                <img class="cert-img-alt mx-auto" src="../../assets/img/ncsa-logo.png"/>
              </a>
            </div>
            <div class="col-12 col-sm-6 d-flex">
              <a href="//getsafeonline.org.rw/" target="_blank" class="mx-auto my-2">
                <img class="cert-img-alt mx-auto" src="../../assets/img/gso-logo.png"/>
              </a>
            </div>
          </div>
        </div>
        <div ref="twitter_timeline" class="col-12 col-lg-4 px-3 pt-4">
          <cert-twitter-timeline :key="twitterHeight" :height="twitterHeight"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CertAwarenessCaroussel from './components/CertAwarenessCaroussel.vue';
import CertAlertCaroussel from './components/CertAlertCaroussel.vue';
import CertAlertCarousselVertical from './components/CertAlertCarousselVertical.vue';
import CertTwitterTimeline from './components/CertTwitterTimeline.vue';

export default {
  name: "Home",
  props: {
    cardBg: String
  },
  components: {
    CertAlertCaroussel,
    CertAlertCarousselVertical,
    CertAwarenessCaroussel,
    CertTwitterTimeline,
  },
  data() {
    return {
      twitterHeight: 0,
    };
  },
  methods: {
    search() {
      let terms = this.$refs['search'].value;
      terms = terms.trim();
      if (terms !== '')
        this.$router.push({name: 'Search', params: {terms: terms}})
    },
  },
  mounted() {
    this.$anim.fadeInBottom(this.$refs["title"], 0);
    this.$anim.fadeInBottom(this.$refs["title-text"], 0);
    this.$anim.fadeInBottom(this.$refs["about-btn"], 0);
    this.$anim.fadeInBottom(this.$refs["awareness"], 0);
    this.$anim.fadeInBottom(this.$refs["alerts"], 200);

    this.twitterHeight=150
    // setTimeout(() => {
    //   this.twitterHeight = this.$refs.advisory_partners.clientHeight;
    // }, 300);
  }
}
</script>
<style>
label.required:after {
  content: '*';
  color: #d85182;
}
</style>
